import React from "react";
import PriceFreezeIcon from "../../assets/icons/amenities/pricefreeze.svg?react";
import EarlyCheckInCalendarIcon from "../../assets/icons/cap1/calendar-icon.svg?react";
import LateCheckoutIcon from "../../assets/icons/cap1/late-checkout-icon.svg?react";
import LuxuryBenefitCashIcon from "../../assets/icons/cap1/luxury-benefit-cash.svg?react";
import LuxuryBenefitMilesIcon from "../../assets/icons/cap1/luxury-benefit-miles.svg?react";
import LuxuryBenefitServiceIcon from "../../assets/icons/cap1/luxury-benefit-service.svg?react";
import MealIcon from "../../assets/icons/cap1/meal-icon.svg?react";
import MoneyBagIcon from "../../assets/icons/cap1/money-bag-icon.svg?react";
import PerksIcon from "../../assets/icons/cap1/perks-icon.svg?react";
import PriceDropProtectionShield from "../../assets/icons/cap1/price-drop-protection-shield.svg?react";
import PriceDropProtectionIcon from "../../assets/icons/cap1/price-drop-protection.svg?react";
import ModalPriceDrop from "../../assets/icons/cap1/price-drop.svg?react";
import PriceFreezeArrow from "../../assets/icons/cap1/price-freeze-arrow.svg?react";
import B2bPriceFreezeNoCircle from "../../assets/icons/cap1/price-freeze-no-circle.svg?react";
import B2bPriceFreeze from "../../assets/icons/cap1/price-freeze.svg?react";
import PriceMatchGuaranteeIcon from "../../assets/icons/cap1/price-match-icon.svg?react";
import PricePredictionIcon from "../../assets/icons/cap1/price-prediction.svg?react";
import UnableToProcess from "../../assets/icons/cap1/unable-to-process.svg?react";
import UpgradeIcon from "../../assets/icons/cap1/upgrade-icon.svg?react";
import WifiIcon from "../../assets/icons/cap1/wifi-icon.svg?react";
import AirConditioningIcon from "../../assets/icons/car/amenities/air-conditioning-icon.svg?react";
import TransmissionIcon from "../../assets/icons/car/transmission-icon.svg?react";
import ErrorAlertIcon from "../../assets/icons/common/alert-error.svg?react";
import WarningAlertIcon from "../../assets/icons/common/alert-warning.svg?react";
import ArrowRight from "../../assets/icons/common/arrow-right.svg?react";
import ArrowDiverge from "../../assets/icons/common/arrow-diverge.svg?react";
import Arrows from "../../assets/icons/common/arrows.svg?react";
import B2BAirplaneIcon from "../../assets/icons/common/b2b-airplane-icon.svg?react";
import B2BEditPencilIcon from "../../assets/icons/common/b2b-edit-pencil.svg?react";
import B2BMapPin from "../../assets/icons/common/b2b-map-pin.svg?react";
import B2BOriginIcon from "../../assets/icons/common/b2b-origin-icon.svg?react";
import B2BPriceWatch from "../../assets/icons/common/b2b-price-watch.svg?react";
import B2BUser from "../../assets/icons/common/b2b-user.svg?react";
import BellWarningIcon from "../../assets/icons/common/bell-warning-icon.svg?react";
import CalendarIcon from "../../assets/icons/common/calendar.svg?react";
import CheckInCalendar from "../../assets/icons/common/check-in-calendar.svg?react";
import CheckOutCalendar from "../../assets/icons/common/check-out-calendar.svg?react";
import CheckCircleFilledBlueIcon from "../../assets/icons/common/check-circle-filled-blue.svg?react";
import CheckCircleIcon from "../../assets/icons/common/check-circle.svg?react";
import CheckCircleFilledIcon from "../../assets/icons/common/check-filled.svg?react";
import CheckCircleOutlineIcon from "../../assets/icons/common/check-circle-outline.svg?react";
import CheckCircleTransparentIcon from "../../assets/icons/common/check-mark-transparent.svg?react";
import CheckShieldBlueIcon from "../../assets/icons/common/check-shield-blue.svg?react";
import CheckShieldIcon from "../../assets/icons/common/check-shield.svg?react";
import CircleAlert from "../../assets/icons/common/circle-alert.svg?react";
import ClockIcon from "../../assets/icons/common/clock.svg?react";
import CarIcon from "../../assets/icons/car/car-icon.svg?react";
import BookTravel from "../../assets/icons/flight/book-travel.svg?react";
import WorldMap from "../../assets/icons/common/world-map.svg?react";
import Close from "../../assets/icons/common/close-button.svg?react";
import Checkmark from "../../assets/icons/common/confirmation-check-mark.svg?react";
import DecreaseIcon from "../../assets/icons/common/decrease-arrow.svg?react";
import Dropdown from "../../assets/icons/common/dropdown.svg?react";
import ExternalLinkIcon from "../../assets/icons/common/external-link-icon.svg?react";
import FilledClock from "../../assets/icons/common/filled-clock.svg?react";
import FilterMenu from "../../assets/icons/common/filter-menu.svg?react";
import FilterMenuThick from "../../assets/icons/common/filter-menu-thick.svg?react";
import PoundCurrencySymbol from "../../assets/icons/common/gbp.svg?react";
import GenericIcon from "../../assets/icons/common/generic.svg?react";
import BellAlertIcon from "../../assets/icons/common/grey-bell-alert-icon.svg?react";
import CheckedIcon from "../../assets/icons/common/grey-checked-icon.svg?react";
import DottedLineIcon from "../../assets/icons/common/grey-dotted-line.svg?react";
import GuaranteeIcon from "../../assets/icons/common/grey-guarantee-icon.svg?react";
import PriceDropIcon from "../../assets/icons/common/grey-price-drop-icon.svg?react";
import IncreaseIcon from "../../assets/icons/common/increase-arrow.svg?react";
import InfoCircleFillIcon from "../../assets/icons/common/info-circle-fill.svg?react";
import InfoCircleWhiteIcon from "../../assets/icons/common/info-white-icon.svg?react";
import InfoCircleIcon from "../../assets/icons/common/info-icon.svg?react";
import MagnifyingGlassIcon from "../../assets/icons/common/magnifying-glass-icon.svg?react";
import MoneyFill from "../../assets/icons/common/money-fill.svg?react";
import MoneyOutlineGBPIcon from "../../assets/icons/common/money-outline-gbp.svg?react";
import MoneyOutlineTransparentIcon from "../../assets/icons/common/money-outline-transparent.svg?react";
import MoneyOutlineIcon from "../../assets/icons/common/money-outline.svg?react";
import NotAllowedSignIcon from "../../assets/icons/common/not-allowed-sign.svg?react";
import PaymentIcon from "../../assets/icons/common/payment.svg?react";
import PencilEditIcon from "../../assets/icons/common/pencil-edit-icon.svg?react";
import PlusOutline from "../../assets/icons/common/plus-outline.svg?react";
import Refresh from "../../assets/icons/common/refresh.svg?react";
import Reload from "../../assets/icons/common/reload.svg?react";
import RewindIcon from "../../assets/icons/common/rewind-time.svg?react";
import ShowAllImagesIcon from "../../assets/icons/common/show-all-images.svg?react";
import StarEmpty from "../../assets/icons/common/star-empty.svg?react";
import StarFilled from "../../assets/icons/common/star-filled.svg?react";
import StarRoundedEmpty from "../../assets/icons/support/star-rounded-empty.svg?react";
import StarRoundedFilled from "../../assets/icons/support/star-rounded-filled.svg?react";
import SubtractIcon from "../../assets/icons/common/subtract.svg?react";
import SuiteCaseIcon from "../../assets/icons/common/suitecase-icon.svg?react";
import Delete from "../../assets/icons/common/trash-bin-icon.svg?react";
import UserIcon from "../../assets/icons/common/user.svg?react";
import B2BWatchCheckedIcon from "../../assets/icons/common/watch-b2b-checked.svg?react";
import B2BWatchIcon from "../../assets/icons/common/watch-b2b.svg?react";
import WatchIcon from "../../assets/icons/common/watch.svg?react";
import XCircleFilled from "../../assets/icons/common/x-circle-filled.svg?react";
import FrozenPriceIcon from "../../assets/icons/flight/frozen-price.svg?react";
import SeatSelectionIcon from "../../assets/icons/flight/seat-selection.svg?react";
import HopperLogo from "../../assets/icons/hopper/hopper-logo.svg?react";
import MapPin from "../../assets/icons/hotel/map-pin.svg?react";
import MapPinRound from "../../assets/icons/hotel/map-pin-round.svg?react";
import CardIcon from "../../assets/icons/payments/card_generic.svg?react";
import DecreaseReviewed from "../../assets/icons/system/DecreaseReviewed.svg?react";
import IncreaseReviewed from "../../assets/icons/system/IncreaseReviewed.svg?react";
import LockIcon from "../../assets/icons/system/lock.svg?react";
import NavigationForwardIcon from "../../assets/icons/system/navigation-forward.svg?react";
import Chevron from "../../assets/icons/uber/chevron.svg?react";
import Bed from "../../assets/icons/hotel/bed.svg?react";
import CheckBunmoji from "../../assets/icons/hopper/check_bunmoji.svg?react";
import SpeechBubbleBunmoji from "../../assets/icons/hopper/speech_bubble_bunmoji.svg?react";
import CircleAirplane from "../../assets/icons/common/circle-airplane.svg?react";
import ChevronDown from "../../assets/icons/common/chevron-down.svg?react";
import ComboFlight from "../../assets/icons/common/combo-flight.svg?react";
import CarryOnBaggage from "../../assets/icons/common/carry-on-baggage.svg?react";
import TripProtection from "../../assets/icons/common/trip-protection.svg?react";
import TripProtectionCrossSolid from "../../assets/icons/common/trip-protection-cross-solid.svg?react";
import ShieldPayment from "../../assets/icons/common/shield-payment.svg?react";
import WalletFlat from "../../assets/icons/hopper/wallet_flat.svg?react";
import CheckSolid from "../../assets/icons/system/check-solid.svg?react";
import DismissOutline from "../../assets/icons/system/dismiss-outline.svg?react";
import Check from "../../assets/icons/common/check.svg?react";
import InfoOutline from "../../assets/icons/common/info-outline.svg?react";
import InfoOutlineTriangle from "../../assets/icons/common/info-outline-triangle.svg?react";
import ClockGreyOutline from "../../assets/icons/common/clock-grey-outline.svg?react";
import PlaneLanding from "../../assets/icons/common/plane-landing.svg?react";
import PlaneTakeoff from "../../assets/icons/common/plane-takeoff.svg?react";
import Ellipse from "../../assets/icons/common/ellipse.svg?react";
import LayoverClock from "../../assets/icons/common/layover-clock.svg?react";
import BaggageCarryOn from "../../assets/icons/common/baggage-carry-on.svg?react";
import ShieldMissedConnection from "../../assets/icons/common/shield-missed-connection.svg?react";
import MultiPlanes from "../../assets/icons/common/multi-planes.svg?react";
import AccordionArrow from "../../assets/icons/common/accordion-arrow.svg?react";
import CrossOutSign from "../../assets/icons/common/cross-out-sign.svg?react";
import Tada from "../../assets/icons/common/tada.svg?react";
import RoundArrowDown from "../../assets/icons/system/round-arrow-down.svg?react";
import SendMessage from "../../assets/icons/support/send-message.svg?react";
import SupportChat from "../../assets/icons/support/support-chat.svg?react";
import SupportChevronRight from "../../assets/icons/support/support-chevron-right.svg?react";
import SupportPhone from "../../assets/icons/support/support-phone.svg?react";

// Large SVGs (>40KB) should not be imported into bundle, and should be loaded from CDN instead
// TODO: Add these bunny images to CDN
// import CalendarBunny from "../../assets/bunnies/calendar_bunny.svg?react";
// import CalendarSuccessBunny from "../../assets/bunnies/calendar_success_bunny.svg?react";
// import SupportBunny from "../../assets/bunnies/support_bunny.svg?react";
// import SupportChatBunny from "../../assets/bunnies/support_chat_bunny.svg?react";
// import SupportSuccessBunny from "../../assets/bunnies/support_success_bunny.svg?react";

import { IconName } from "../Icon/component";
import "./styles.scss";
interface PropsWithAlt extends React.SVGProps<SVGSVGElement> {
  alt?: string;
}

export type SvgrComponent = React.FunctionComponent<PropsWithAlt>;

type IconComponentMap = {
  [name in IconName]: SvgrComponent;
};

export const iconComponentMap: Partial<IconComponentMap> = {
  [IconName.MoneyOutline]: MoneyOutlineIcon,
  [IconName.MoneyOutlineGBP]: MoneyOutlineGBPIcon,
  [IconName.MoneyOutlineTransparentIcon]: MoneyOutlineTransparentIcon,
  [IconName.MoneyFill]: MoneyFill,
  [IconName.CheckBunmoji]: CheckBunmoji,
  [IconName.CheckCircle]: CheckCircleIcon,
  [IconName.Payment]: PaymentIcon,
  [IconName.CheckCircleTransparent]: CheckCircleTransparentIcon,
  [IconName.CheckCircleOutline]: CheckCircleOutlineIcon,
  [IconName.CheckShield]: CheckShieldIcon,
  [IconName.CheckShieldBlue]: CheckShieldBlueIcon,
  [IconName.NotAllowedSign]: NotAllowedSignIcon,
  [IconName.PriceFreeze]: PriceFreezeIcon,
  [IconName.NavigationForward]: NavigationForwardIcon,
  [IconName.Lock]: LockIcon,
  [IconName.Person]: UserIcon,
  [IconName.User]: UserIcon,
  [IconName.Rewind]: RewindIcon,
  [IconName.Card]: CardIcon,
  [IconName.Watch]: WatchIcon,
  [IconName.Increase]: IncreaseIcon,
  [IconName.Decrease]: DecreaseIcon,
  [IconName.MapPin]: MapPin,
  [IconName.MapPinRound]: MapPinRound,
  [IconName.B2BWatch]: B2BWatchIcon,
  [IconName.B2BWatchChecked]: B2BWatchCheckedIcon,
  [IconName.IncreasedReviewed]: IncreaseReviewed,
  [IconName.DecreaseReviewed]: DecreaseReviewed,
  [IconName.PlusOutline]: PlusOutline,
  [IconName.PencilEdit]: PencilEditIcon,
  [IconName.ErrorAlert]: ErrorAlertIcon,
  [IconName.WarningAlert]: WarningAlertIcon,
  [IconName.InfoCircle]: InfoCircleIcon,
  [IconName.InfoCircleFill]: InfoCircleFillIcon,
  [IconName.InfoWhiteCircle]: InfoCircleWhiteIcon,
  [IconName.Calendar]: CalendarIcon,
  [IconName.CheckInCalendar]: CheckInCalendar,
  [IconName.CheckOutCalendar]: CheckOutCalendar,
  [IconName.B2BEditPencil]: B2BEditPencilIcon,
  [IconName.Dropdown]: Dropdown,
  [IconName.B2BUser]: B2BUser,
  [IconName.B2BMapPin]: B2BMapPin,
  [IconName.SuiteCase]: SuiteCaseIcon,
  [IconName.Transmission]: TransmissionIcon,
  [IconName.AirConditioning]: AirConditioningIcon,
  [IconName.ClockIcon]: ClockIcon,
  [IconName.Car]: CarIcon,
  [IconName.BookTravel]: BookTravel,
  [IconName.WorldMap]: WorldMap,
  [IconName.CircleAirplane]: CircleAirplane,
  [IconName.CheckCircleFilled]: CheckCircleFilledIcon,
  [IconName.Generic]: GenericIcon,
  [IconName.MagnifyingGlass]: MagnifyingGlassIcon,
  [IconName.B2BAirplaneIcon]: B2BAirplaneIcon,
  [IconName.B2BOriginIcon]: B2BOriginIcon,
  [IconName.ShowAllImagesIcon]: ShowAllImagesIcon,
  [IconName.StarFilled]: StarFilled,
  [IconName.StarEmpty]: StarEmpty,
  [IconName.StarRoundedFilled]: StarRoundedFilled,
  [IconName.StarRoundedEmpty]: StarRoundedEmpty,
  [IconName.B2BPriceWatch]: B2BPriceWatch,
  [IconName.ExternalLinkIcon]: ExternalLinkIcon,
  [IconName.UnableToProcess]: UnableToProcess,
  [IconName.B2bPriceFreeze]: B2bPriceFreeze,
  [IconName.B2bPriceFreezeNoCircle]: B2bPriceFreezeNoCircle,
  [IconName.PriceDropProtectionIcon]: PriceDropProtectionIcon,
  [IconName.PriceDropProtectionShield]: PriceDropProtectionShield,
  [IconName.Guarantee]: GuaranteeIcon,
  [IconName.BellAlert]: BellAlertIcon,
  [IconName.PriceDrop]: PriceDropIcon,
  [IconName.Checked]: CheckedIcon,
  [IconName.PricePredictionIcon]: PricePredictionIcon,
  [IconName.PriceMatchGuaranteeIcon]: PriceMatchGuaranteeIcon,
  [IconName.DottedLine]: DottedLineIcon,
  [IconName.PriceFreezeArrow]: PriceFreezeArrow,
  [IconName.SeatSelectionIcon]: SeatSelectionIcon,
  [IconName.FrozenPrice]: FrozenPriceIcon,
  [IconName.BellWarning]: BellWarningIcon,
  [IconName.MoneyBag]: MoneyBagIcon,
  [IconName.LuxuryBenefitMilesIcon]: LuxuryBenefitMilesIcon,
  [IconName.LuxuryBenefitCashIcon]: LuxuryBenefitCashIcon,
  [IconName.LuxuryBenefitServiceIcon]: LuxuryBenefitServiceIcon,
  [IconName.EarlyCheckInCalendarIcon]: EarlyCheckInCalendarIcon,
  [IconName.MealIcon]: MealIcon,
  [IconName.UpgradeIcon]: UpgradeIcon,
  [IconName.LateCheckoutIcon]: LateCheckoutIcon,
  [IconName.WifiIcon]: WifiIcon,
  [IconName.PerksIcon]: PerksIcon,
  [IconName.CheckCircleFilledBlue]: CheckCircleFilledBlueIcon,
  [IconName.ModalPriceDrop]: ModalPriceDrop,
  [IconName.HopperLogo]: HopperLogo,
  [IconName.FilterMenu]: FilterMenu,
  [IconName.FilterMenuThick]: FilterMenuThick,
  [IconName.Checkmark]: Checkmark,
  [IconName.Delete]: Delete,
  [IconName.Close]: Close,
  [IconName.XCircleFilled]: XCircleFilled,
  [IconName.PoundCurrencySymbol]: PoundCurrencySymbol,
  [IconName.Subtract]: SubtractIcon,
  [IconName.ArrowDiverge]: ArrowDiverge,
  [IconName.Arrows]: Arrows,
  [IconName.FilledClock]: FilledClock,
  [IconName.CircleAlert]: CircleAlert,
  [IconName.Chevron]: Chevron,
  [IconName.Refresh]: Refresh,
  [IconName.Reload]: Reload,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.Bed]: Bed,
  [IconName.SpeechBubbleBunmoji]: SpeechBubbleBunmoji,
  [IconName.ChevronDown]: ChevronDown,
  [IconName.ComboFlight]: ComboFlight,
  [IconName.CarryOnBaggage]: CarryOnBaggage,
  [IconName.TripProtection]: TripProtection,
  [IconName.TripProtectionCrossSolid]: TripProtectionCrossSolid,
  [IconName.ShieldPayment]: ShieldPayment,
  [IconName.WalletFlat]: WalletFlat,
  [IconName.CheckSolid]: CheckSolid,
  [IconName.DismissOutline]: DismissOutline,
  // [IconName.CalendarBunny]: CalendarBunny,
  // [IconName.CalendarSuccessBunny]: CalendarSuccessBunny,
  // [IconName.SupportBunny]: SupportBunny,
  // [IconName.SupportChatBunny]: SupportChatBunny,
  // [IconName.SupportSuccessBunny]: SupportSuccessBunny,
  [IconName.Check]: Check,
  [IconName.InfoOutline]: InfoOutline,
  [IconName.InfoOutlineTriangle]: InfoOutlineTriangle,
  [IconName.ClockGreyOutline]: ClockGreyOutline,
  [IconName.PlaneLanding]: PlaneLanding,
  [IconName.PlaneTakeoff]: PlaneTakeoff,
  [IconName.Ellipse]: Ellipse,
  [IconName.LayoverClock]: LayoverClock,
  [IconName.BaggageCarryOn]: BaggageCarryOn,
  [IconName.ShieldMissedConnection]: ShieldMissedConnection,
  [IconName.MultiPlanes]: MultiPlanes,
  [IconName.AccordionArrow]: AccordionArrow,
  [IconName.CrossOutSign]: CrossOutSign,
  [IconName.Tada]: Tada,
  [IconName.RoundArrowDown]: RoundArrowDown,
  [IconName.SendMessage]: SendMessage,
  [IconName.SupportChat]: SupportChat,
  [IconName.SupportChevronRight]: SupportChevronRight,
  [IconName.SupportPhone]: SupportPhone,
};

export interface IconComponentProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  className?: string;
  ariaLabel?: string | null;
}

export const IconComponent = ({
  name,
  ariaLabel,
  ...props
}: IconComponentProps): React.ReactElement<any> => {
  const IconComponent = iconComponentMap[name] as SvgrComponent;
  return (
    <IconComponent
      {...props}
      className={`${props.className} icon-component`}
      aria-label={ariaLabel ?? name}
    />
  );
};
